import { marked } from "marked";

// 创建自定义渲染器
const renderer = new marked.Renderer();

// 重写渲染器中的链接渲染方法
renderer.link = function (href, _title, text) {
  const targetAttribute = 'target="_blank"';
  const link = `<a href="${href}"${targetAttribute}>${text}</a>`;
  return link;
};

export const getHtml = (markdown: string) =>
  marked.parse(markdown ?? "", { renderer });
